<template>
    <div class="last">
        <div class="bg"></div>
        <div class="inner">
            <div class="left">
                <div class="info">
                <span class="point">
                    <span class="text">
                        Москва, Коломенское
                    </span>
                </span>
                    <h3 class="head">
                        Weleda на Пикнике «Афиши»!
                    </h3>
                    <span class="desc">
                        4&nbsp;августа в&nbsp;парке &laquo;Коломенское&raquo; прошел грандиозный Пикник &laquo;Афиши&raquo;, на&nbsp;котором специально для вас мы&nbsp;создали отдельный уголок природы.
                        Здесь можно было почувствовать аромат лимонов, ощутить магию летнего сада и&nbsp;поближе познакомиться с&nbsp;натуральной косметикой.
                        Вновь насладиться моментом можно в&nbsp;нашем <a @click.native="gaEvents('main','click','instagram')"  target="_blank" class="line" href="https://www.instagram.com/weledarussia">Instagram</a> по тегу <strong>#WeledaPicnic</strong>
                    </span>
                    <span class="desc">
                        <a style="text-decoration: underline" href="/static/pdf/rules.pdf" target="_blank">Правила участия</a>
                    </span>
                    <a @click="show" class="btn btn-promo">
                        Получить скидку на косметику
                    </a>
                    <div class="footnote"><p>*Веледа</p></div>
                </div>
            </div>
            <Form :showForm="showForm" :showCloseMobile="true" @closeForm="close"></Form>
        </div>
    </div>
</template>

<script>
    import {TweenMax} from 'gsap'
    import Form from '@/components/common/Form';
    import Helpers from '@/tools/Helpers';

    export default {
        name: 'last',
        components: {
            Form
        },
        data(){
            return {
                showForm: false
            }
        },

        methods:{
            gaEvents(ctegory,event,label){
                Helpers.ga().send(ctegory,event,label);
            },

            show(){
                this.showForm = true;
                this.gaEvents('product','click','get code');
            },

            close(){
                this.showForm = false;
                this.gaEvents('product','click','close popup');
            }
        },

    }
</script>

<style>

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 1s;
    }

    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

</style>



// WEBPACK FOOTER //
// last.vue?7ecfedd2